import perksGOTracking from "@irati-tracking/perksgo/perksGO"

interface MobileMenuItemsParams {
  showFidel: boolean,
  showCustomisation: boolean
}

export default ({showFidel, showCustomisation}: MobileMenuItemsParams) => [
  {
    label: "account.profile.label",
    to: "/profile"
  },
  {
    label: "account.contact.label",
    to: "/settings/contact"
  },
  {
    label: "account.payment.label",
    to: "/settings/payment"
  },
  showFidel && {
    label: "account.linked.label",
    to: "/settings/linkedcards",
    onClick: perksGOTracking.clickMyLinkedCards
  },
  {
    label: "account.password.label",
    to: "/settings/password"
  },
  {
    label: "account.security.label",
    to: "/settings/security"
  },
  showCustomisation && {
    label: "account.customisation.interests.label",
    to: "/settings/customisation/categories"
  }
]
